import { render, staticRenderFns } from "./ActorDetail.vue?vue&type=template&id=890771de"
import script from "./ActorDetail.vue?vue&type=script&lang=js"
export * from "./ActorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports